export const ContactUsIcon = ({ fill = '#fff', hoverFill = '#FAFAFA' }) => {
  return (
    <svg
      width="56"
      height="57"
      viewBox="0 0 56 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="28" cy="28.5" r="28" fill={hoverFill} />
      <circle cx="28" cy="28.5" r="28" stroke="#E9E9E9" />
      <rect
        width="24"
        height="24"
        transform="translate(16 16.5)"
        fill={hoverFill}
      />
      <path
        d="M24 27.5C24.2833 27.5 24.5208 27.4042 24.7125 27.2125C24.9042 27.0208 25 26.7833 25 26.5C25 26.2167 24.9042 25.9792 24.7125 25.7875C24.5208 25.5958 24.2833 25.5 24 25.5C23.7167 25.5 23.4792 25.5958 23.2875 25.7875C23.0958 25.9792 23 26.2167 23 26.5C23 26.7833 23.0958 27.0208 23.2875 27.2125C23.4792 27.4042 23.7167 27.5 24 27.5ZM28 27.5C28.2833 27.5 28.5208 27.4042 28.7125 27.2125C28.9042 27.0208 29 26.7833 29 26.5C29 26.2167 28.9042 25.9792 28.7125 25.7875C28.5208 25.5958 28.2833 25.5 28 25.5C27.7167 25.5 27.4792 25.5958 27.2875 25.7875C27.0958 25.9792 27 26.2167 27 26.5C27 26.7833 27.0958 27.0208 27.2875 27.2125C27.4792 27.4042 27.7167 27.5 28 27.5ZM32 27.5C32.2833 27.5 32.5208 27.4042 32.7125 27.2125C32.9042 27.0208 33 26.7833 33 26.5C33 26.2167 32.9042 25.9792 32.7125 25.7875C32.5208 25.5958 32.2833 25.5 32 25.5C31.7167 25.5 31.4792 25.5958 31.2875 25.7875C31.0958 25.9792 31 26.2167 31 26.5C31 26.7833 31.0958 27.0208 31.2875 27.2125C31.4792 27.4042 31.7167 27.5 32 27.5ZM18 38.5V20.5C18 19.95 18.1958 19.4792 18.5875 19.0875C18.9792 18.6958 19.45 18.5 20 18.5H36C36.55 18.5 37.0208 18.6958 37.4125 19.0875C37.8042 19.4792 38 19.95 38 20.5V32.5C38 33.05 37.8042 33.5208 37.4125 33.9125C37.0208 34.3042 36.55 34.5 36 34.5H22L18 38.5ZM21.15 32.5H36V20.5H20V33.625L21.15 32.5Z"
        fill={fill}
      />
    </svg>
  );
};

export const RespContactUsIcon = ({ fill = '#fff' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <rect width="24" height="24" fill="#FAFAFA" />
      <path
        d="M8 11C8.28333 11 8.52083 10.9042 8.7125 10.7125C8.90417 10.5208 9 10.2833 9 10C9 9.71667 8.90417 9.47917 8.7125 9.2875C8.52083 9.09583 8.28333 9 8 9C7.71667 9 7.47917 9.09583 7.2875 9.2875C7.09583 9.47917 7 9.71667 7 10C7 10.2833 7.09583 10.5208 7.2875 10.7125C7.47917 10.9042 7.71667 11 8 11ZM12 11C12.2833 11 12.5208 10.9042 12.7125 10.7125C12.9042 10.5208 13 10.2833 13 10C13 9.71667 12.9042 9.47917 12.7125 9.2875C12.5208 9.09583 12.2833 9 12 9C11.7167 9 11.4792 9.09583 11.2875 9.2875C11.0958 9.47917 11 9.71667 11 10C11 10.2833 11.0958 10.5208 11.2875 10.7125C11.4792 10.9042 11.7167 11 12 11ZM16 11C16.2833 11 16.5208 10.9042 16.7125 10.7125C16.9042 10.5208 17 10.2833 17 10C17 9.71667 16.9042 9.47917 16.7125 9.2875C16.5208 9.09583 16.2833 9 16 9C15.7167 9 15.4792 9.09583 15.2875 9.2875C15.0958 9.47917 15 9.71667 15 10C15 10.2833 15.0958 10.5208 15.2875 10.7125C15.4792 10.9042 15.7167 11 16 11ZM2 22V4C2 3.45 2.19583 2.97917 2.5875 2.5875C2.97917 2.19583 3.45 2 4 2H20C20.55 2 21.0208 2.19583 21.4125 2.5875C21.8042 2.97917 22 3.45 22 4V16C22 16.55 21.8042 17.0208 21.4125 17.4125C21.0208 17.8042 20.55 18 20 18H6L2 22ZM5.15 16H20V4H4V17.125L5.15 16Z"
        fill={fill}
      />
    </svg>
  );
};
